import { IVerifyResponse } from "../interfaces/IVerifyResponse";
import { IUserSession } from "../interfaces/IUserSession";

export function mapVerifyResponseToUserSession(result: IVerifyResponse): IUserSession {
    return {
        user: {
            id: result.id,
            name: result.name,
            email: result.email,
            image: result.imageUrl,
        },
        configuration: {
            selectedCompanyId: result.configuration.selectedCompanyId,
            mode: 'light',
            primaryColour: '#493193',
            secondaryColour: '#2fadd8',
            IsTestCompany: result.configuration.isTestCompany
        },
        companies: result.companies,
        token: result.token,
        logoutToken: result.logoutToken,
        roles: result.roles
    };
}